import HBSelect from "@/components/HBInput/select";
import HBMessage from "@/components/HBMessage";
import useAppStore from "@/context/store";
import { updateBoard } from "@/services";
import { isDown, isEnter, isUp } from "@/utils/keyBoard";
import { Button, Input } from "antd";
import classNames from "classnames";
import { useCallback, useEffect, useRef, useState } from "react";
import HBLoading from "../../HBLoading";
import HBTagInput from "../../HBTagInput";
import MyBoardFilter from "../../MyBoardFilter";
import styles from "../index.module.less";
import Search from "./Search";

const getBoardHoverMask = ({ pinToBoard }) =>
  function BoardHoverMask({ board }) {
    const categories = useAppStore((store) => store.categories);
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState(board?.category_id);

    const onCategoryChange = useCallback(
      async (value) => {
        const { err } = await updateBoard({
          board_id: board.board_id,
          category: value,
        });
        if (!err) {
          HBMessage.success("画板分类修改成功");
          board.category_id = value;
          setValue(value);
        }
      },
      [board]
    );

    return (
      <div
        className={classNames([
          styles.mask,
          "mask",
          visible ? styles.show : null,
        ])}
        onClick={() => pinToBoard(board)}
      >
        <div
          className={styles.select}
          data-gd-click="button_click"
          data-button-name="选择画板分类"
          data-content-source="采集弹窗"
          onClick={(evt) => evt.stopPropagation()}
        >
          <HBSelect
            wrapClassName={styles.wrap}
            {...(value ? { value } : null)}
            placement="bottomRight"
            placeholder="选择分类"
            optLabel="name"
            dropdownClassName={styles.dropdown}
            options={categories}
            onChange={onCategoryChange}
            noWrapper={true}
            onDropdownVisibleChange={(visible) => setVisible(visible)}
          />
        </div>
        <Button className={styles.pickBtn} type="primary">
          采下来
        </Button>
      </div>
    );
  };

export default function Creator(props) {
  const {
    onTagsChange,
    onDescriptionChange,
    onKeywordChange,
    onCreateBoardClick,
    canItemShow,
    onAvailBoardsUpdate,
    pinToBoard,
    setSelected,
    getSelected,

    boards,
    keyword,
    tip,
    targetAvatarUrl,
    suggestTags,
    result,
    loading,
    availBoards,
    selected,
  } = props.viewModel;

  const searchInputRef = useRef();

  useEffect(() => {
    const handler = (e) => {
      // focus 在特定元素时，阻止键盘操作选则画板
      const inputsToExclude = Array.from(
        document.querySelectorAll(
          `.${styles.descBlock} textarea, .${styles.tagBlock} input`
        )
      );
      if (inputsToExclude.includes(document.activeElement)) {
        return;
      }

      const boards = availBoards.current;

      if (!boards.length) return;

      const selected = getSelected();

      // press enter
      if (isEnter(e)) {
        if (!selected.length) {
          const [defaultBoard] = boards;
          defaultBoard && pinToBoard(defaultBoard);
        } else {
          const b = boards.find((b) => b.board_id === selected[0]);
          b && pinToBoard(b);
        }
      }

      if (isUp(e) || isDown(e)) {
        e.preventDefault();
        e.stopPropagation();
        const step = isDown(e) ? 1 : -1;
        const curIdx = boards.findIndex((b) => b.board_id === selected[0]);
        if (curIdx < 0) {
          setSelected([boards[0].board_id]);
          return;
        }

        let nextIdx = curIdx + step;
        nextIdx =
          nextIdx >= boards.length
            ? 0
            : nextIdx < 0
            ? boards.length - 1
            : nextIdx;

        const nextBoardId = [boards[nextIdx].board_id];
        setSelected(nextBoardId);

        const target = document.querySelector(
          `[data-board-id="${nextBoardId}"]`
        );
        target.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    };
    document.addEventListener("keydown", handler);
    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [canItemShow, availBoards, pinToBoard, getSelected, setSelected]);

  useEffect(() => {
    searchInputRef.current?.input?.focus();
  }, []);

  return (
    <div className={styles.creator}>
      <div className={styles.right}>
        <div className={styles.wrapper}>
          <div className={styles.title}>采集</div>
          <Search
            onChange={onKeywordChange}
            hideSearchBtn
            value={keyword}
            placeholder={"搜索或创建画板"}
            ref={searchInputRef}
          />

          {loading ? (
            <div
              style={{
                paddingTop: "120px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <HBLoading size={"24px"} />
            </div>
          ) : !boards.length && !keyword ? (
            <div
              style={{
                height: "22px",
                lineHeight: "22px",
                fontSize: "14px",
                fontWeight: "400",
                marginTop: "12px",
              }}
            >
              尚无画板，请输入名称以创建画板
            </div>
          ) : (
            <>
              {tip}
              <MyBoardFilter
                className={classNames(styles.boards, "custom-scroll")}
                boards={boards}
                keyword={keyword}
                BoardHoverMask={getBoardHoverMask({ pinToBoard })}
                onCreateBoard={onCreateBoardClick}
                canItemShow={canItemShow}
                selectable={true}
                onBoardClick={pinToBoard}
                onBoardsUpdate={onAvailBoardsUpdate}
                value={selected}
              />
            </>
          )}
        </div>
      </div>

      <div className={styles.left}>
        <div className={styles.emptyHolder}></div>
        {targetAvatarUrl ? (
          <div className={styles.image}>
            <img src={targetAvatarUrl} alt={"封面"} />
          </div>
        ) : (
          <div className={classNames([styles.image, styles.bg])}></div>
        )}
        <div className={styles.descBlock}>
          <Input.TextArea
            type={"textarea"}
            placeholder={"添加描述"}
            onChange={onDescriptionChange}
            value={result.current.description}
          />
        </div>
        <HBTagInput
          className={classNames(styles.tagBlock, {
            [styles.noSuggestTags]: !suggestTags?.length,
          })}
          placeholder={"输入标签"}
          suggestTags={suggestTags}
          onChange={onTagsChange}
          open={false}
          tags={result.current.tags}
        />
      </div>
    </div>
  );
}
